import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "item-box" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = { class: "operating-btn" }
const _hoisted_4 = { class: "order-info contact-box" }
const _hoisted_5 = { class: "user-brief" }
const _hoisted_6 = { class: "avatar" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "meta" }
const _hoisted_9 = { class: "username" }
const _hoisted_10 = { class: "item-box" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "订单类型:", -1)
const _hoisted_12 = { class: "value" }
const _hoisted_13 = {
  key: 0,
  class: "item-box"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "自提门店:", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "item-box" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "订单编号:", -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "item-box" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "下单时间:", -1)
const _hoisted_21 = { class: "value" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "发货单号:", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 2,
  class: "item-box"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "联系人:", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = {
  key: 3,
  class: "item-box"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "地址:", -1)
const _hoisted_29 = { class: "value" }
const _hoisted_30 = { class: "item-box" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "备注:", -1)
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "order-info goods-box" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "info-box" }
const _hoisted_36 = { class: "name" }
const _hoisted_37 = { class: "spec" }
const _hoisted_38 = { class: "quantity" }
const _hoisted_39 = { class: "order-info data-box" }
const _hoisted_40 = { class: "item-box" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "订单金额", -1)
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "item-box" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "运费", -1)
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "item-box" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "分销", -1)
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "order-info operate-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_comp_menu = _resolveComponent("comp-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "head-box",
      style: _normalizeStyle({ backgroundColor: $options.getOrderStatusColor($props.item)})
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString($options.getOrderStatus($props.item)), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_elem_icon, { name: "operating" }),
        _createVNode(_component_comp_menu, {
          absolute: true,
          position: "follow",
          maxWidth: "200px",
          value: $options.getMenu($props.item),
          onSelect: _cache[0] || (_cache[0] = ($event: any) => ($options.onSelectMenu($props.item, $event)))
        }, null, 8, ["value"])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            class: "img",
            src: $options.getOrderUserAvatar($props.item),
            onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.onUserAvatarError && $options.onUserAvatarError(...args)))
          }, null, 40, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString($options.getOrderUserName($props.item)), 1),
          _createElementVNode("p", {
            class: _normalizeClass(["phone", { clickable: $options.getOrderUserPhone($props.item) !== '-' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.getOrderUserPhone($props.item) !== '-' && $options.copyText($options.getOrderUserPhone($props.item))))
          }, _toDisplayString($options.getOrderUserPhone($props.item)), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, _toDisplayString({ 1: "快递配送", 2: "配送上门", 3: "到店自提", 4: "堂食", 5: "无需配送" }[$props.item.pathway] || "未知"), 1)
      ]),
      ($props.item.store)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("p", _hoisted_15, _toDisplayString($props.item.store.storeName), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("p", _hoisted_18, _toDisplayString($props.item.orderNumber), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, _toDisplayString($props.item.createdDate), 1)
      ]),
      ($props.item.expressNumber)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "item-box",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($props.item.expressNumber && $options.copyText($props.item.expressNumber)))
          }, [
            _hoisted_22,
            _createElementVNode("p", _hoisted_23, _toDisplayString($props.item.expressNumber), 1)
          ]))
        : _createCommentVNode("", true),
      ($props.item.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("p", _hoisted_26, _toDisplayString([$props.item.address.name, $props.item.address.phone].join(" - ")), 1)
          ]))
        : _createCommentVNode("", true),
      ($props.item.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("p", _hoisted_29, _toDisplayString([$props.item.address.province, $props.item.address.city, $props.item.address.district, $props.item.address.address].join(" - ")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("p", _hoisted_32, _toDisplayString($props.item.remark || "-"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.goodsItems, (goods, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: idx,
          title: goods.title
        }, [
          _createElementVNode("div", {
            class: "img",
            style: _normalizeStyle({ 'background-image': 'url(' + goods.cover.url + '?x-oss-process=image/resize,m_fill,h_300,w_300,limit_0' + ')' })
          }, null, 4),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, _toDisplayString(goods.title), 1),
            _createElementVNode("div", _hoisted_37, _toDisplayString(goods.specification?.map(v => v.title).join(', ')), 1),
            _createElementVNode("div", _hoisted_38, "x" + _toDisplayString(goods.quantity), 1)
          ])
        ], 8, _hoisted_34))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("p", _hoisted_42, "￥" + _toDisplayString($options.centsToYuan($props.item.price)), 1)
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("p", _hoisted_45, "￥" + _toDisplayString($options.centsToYuan($props.item.postagePrice)), 1)
      ]),
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("p", _hoisted_48, _toDisplayString($props.item.distribution ? $props.item.distribution.name : "-"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      ($options.isTransportStatus($props.item, 'WAITING_ACCEPT'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "item g",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.onAccepted($props.item)))
          }, "接单"))
        : ($options.isTransportStatus($props.item, 'PREPARING'))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "item b",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.onPrepared($props.item)))
            }, "备货完成"))
          : ($options.isTransportStatus($props.item, 'WAITING_SHIPMENTS') && $props.item.orderType === 'VIRTUAL_GOODS')
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "item b",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.onVirtualDelivery($props.item)))
              }, "发货"))
            : ($options.isTransportStatus($props.item, 'WAITING_SHIPMENTS'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 3,
                  class: "item b",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.onShipments($props.item)))
                }, "发货"))
              : ($options.isTransportStatus($props.item, 'WAITING_DELIVERED'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: "item b",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.onStartDelivery($props.item)))
                  }, "开始配送"))
                : ($options.isTransportStatus($props.item, 'DELIVERING'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 5,
                      class: "item b",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.onDelivered($props.item)))
                    }, "已送达"))
                  : _createCommentVNode("", true)
    ])
  ]))
}